import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ceaProfileList: [],
  onPage: 0,
  pageSize: 0,
  totalPages: 0,
  totalRecords: 0,
  isLoading: false,
  errorMessage: undefined,
};

const drmCeaProfileListSlice = createSlice({
  name: "drmCeaProfileList",
  initialState,
  reducers: {
    getCeaProfileList: (state) => {
      state.isLoading = true;
    },
    setCeaProfileListSuccess: (state, action) => {
      return { ...state, ...action.payload, isLoading: false };
    },
    setCeaProfileListFailure: (state, action) => {
      return { ...state, errorMessage: action.payload, isLoading: false };
    },
    resetCeaProfileList: () => initialState,
  },
});

export const {
  getCeaProfileList,
  setCeaProfileListSuccess,
  setCeaProfileListFailure,
  resetCeaProfileList,
} = drmCeaProfileListSlice.actions;

export default drmCeaProfileListSlice.reducer;
